import joi from 'joi';

export type AttributeFilters = {
  [attributeName: string]: string[];
};

export const attributeFiltersSchema = joi
  .object()
  .pattern(joi.string(), joi.array().items(joi.string()));
